import React from "react";

const React360Wrapper = () => {
  return (
    <div>
      <iframe
        src="https://tourmkr.com/F1JQdWh9Q6"
        width="100%"
        height="580"
        frameborder="0"
        allowfullscreen="allowfullscreen"
        title="view"
      ></iframe>
    </div>
  );
};

export default React360Wrapper;
